var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordmark60(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 60,
    height: 12.2828,
    viewBox: "0 0 60 12.2828",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_0_38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 5.99122C0 2.41661 2.74074 0 6.51712 0C9.72514 0 12.2488 1.83682 12.6167 4.54253L9.34236 4.88114C9.07558 3.65766 7.93886 2.7712 6.6182 2.7712C4.78055 2.7712 3.52617 4.06016 3.52617 5.99281C3.54274 7.92546 4.79546 9.21443 6.59997 9.21443C7.90406 9.21443 9.07392 8.34553 9.35728 7.13643L12.6316 7.50699C12.3317 10.1808 9.79142 12 6.51546 12C2.74074 12 0 9.56742 0 5.99122Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 12L15.7446 0H20.9035L24.6316 12H21.0207L20.4546 10.1734H16.177L15.6109 12H12ZM16.8767 7.66039H19.773L18.4082 3.00166H18.2415L16.8767 7.66039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38.5263 12V0H41.9228V4.79335H45.8667V0H49.2632V12H45.8667V7.31136H41.9228V12H38.5263Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M50.5263 12V0H59.8309V2.78227H53.9711V4.79335H59.5093V7.08864H53.9711V9.21773H60V12H50.5263Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.4737 2.82603C33.4737 2.40049 33.6575 2.03311 34.0287 1.72544C34.3981 1.41776 34.8373 1.26316 35.3482 1.26316C35.8591 1.26316 36.3369 1.41776 36.7082 1.72544C37.0775 2.03311 37.2632 2.40049 37.2632 2.82603C37.2632 3.27301 37.0775 3.64957 36.7082 3.95877C36.3388 4.26645 35.8848 4.42105 35.3482 4.42105C34.8116 4.42105 34.3962 4.26645 34.0287 3.95877C33.6575 3.6511 33.4737 3.27301 33.4737 2.82603Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M30.9474 12C27.4648 12 24.6316 9.30847 24.6316 6C24.6316 2.69153 27.4648 0 30.9474 0V3.16942C29.3036 3.16942 27.9678 4.44006 27.9678 6C27.9678 7.55994 29.3053 8.83058 30.9474 8.83058C32.5894 8.83058 33.9269 7.56153 33.9269 6H37.2632C37.2632 9.30847 34.43 12 30.9474 12Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 12.2828,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordmark60);
export default __webpack_public_path__ + "static/media/wordmark-60.7be79f56456a7e42dc0e8b9d42ba3f09.svg";
export { ForwardRef as ReactComponent };